import { createSelector } from 'reselect'

export const getAgentsLoading = createSelector(
  (state) => state && state.user && state.user.profile && state.user.profile.agents
    ? state.user.profile.agents.isLoading : false,
  (agentsLoading) => agentsLoading
)
